'use strict';

var ReachMaxWarningDirective = function ReachMaxWarningDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/reach-max-warning.html')
  };
};
ReachMaxWarningDirective.$inject = [];
module.exports = ReachMaxWarningDirective;